import { CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { findAdjacentCycle } from './findAdjacentCycle';
import { SwitchToHigherCycle } from './SwitchToHigherCycle';
import { SwitchToLowerCycle } from './SwitchToLowerCycle';
export const ChangePlanCycle = _ref => {
  let {
    switchedViaBanner,
    onSwitchCycle
  } = _ref;
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isMultiYearUpsellEnabled = experiments.isEnabled('upgradeCycleUpsellCheckout');
  const isSaleUpsellEnabled = experiments.isEnabled('upgradeCycleUpsellCheckoutSales');
  const {
    data: productPricing
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProductPricing({
    productId: selectedProductId || ''
  }, Boolean(selectedProductId));
  const {
    data: offeringDiscount
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const items = (productPricing == null ? void 0 : productPricing.cyclePricingItems) ?? [];
  const isMonthly = selectedCycle ? CycleUtils.isMonthly(selectedCycle) : false;
  const higherCycle = selectedCycle ? findAdjacentCycle(items, selectedCycle, 'higher') : undefined;
  const lowerCycle = selectedCycle ? findAdjacentCycle(items, selectedCycle, 'lower') : undefined;

  // Offering-level sale picks the treatment; `undefined` (in flight) shows neither.
  const hasSale = offeringDiscount == null ? void 0 : offeringDiscount.hasSale;
  const isUpsellEnabled = hasSale === true ? isSaleUpsellEnabled : hasSale === false ? isMultiYearUpsellEnabled : false;
  const isTransitionEnabled = target => {
    const involvesMonthly = isMonthly || (target ? CycleUtils.isMonthly(target.cycle) : false);
    return isUpsellEnabled && !involvesMonthly;
  };
  const showSwitchToHigherCycle = Boolean(higherCycle) && isTransitionEnabled(higherCycle) && !switchedViaBanner;
  const showSwitchToLowerCycle = switchedViaBanner && !isMonthly && Boolean(lowerCycle) && isTransitionEnabled(lowerCycle);
  if (showSwitchToHigherCycle && higherCycle) {
    return /*#__PURE__*/React.createElement(SwitchToHigherCycle, {
      targetPricing: higherCycle,
      items: items,
      isSale: hasSale === true,
      onSwitchCycle: onSwitchCycle
    });
  }
  if (showSwitchToLowerCycle && lowerCycle) {
    return /*#__PURE__*/React.createElement(SwitchToLowerCycle, {
      targetPricing: lowerCycle,
      onSwitchCycle: onSwitchCycle
    });
  }
  return null;
};
//# sourceMappingURL=ChangePlanCycle.js.map